export enum MobileOperationSystem {
  IOS = 'ios',
  ANDROID = 'android',
  UNKNOWN = 'unknown',
}
